import { useEffect, useState } from "react";
import { api, type Position } from "../api";
import { sanitizeTrail, type TrailPoint } from "../lib/vehicle-track";

export function usePositionHistory(deviceId: string | null) {
  const [points, setPoints] = useState<TrailPoint[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!deviceId) {
      setPoints([]);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setPoints([]);
    void api<{ positions: Position[] }>(`/api/devices/${encodeURIComponent(deviceId)}/positions?limit=400`)
      .then((data) => {
        if (cancelled) return;
        const chronological = [...(data.positions ?? [])].reverse();
        setPoints(sanitizeTrail(chronological));
      })
      .catch(() => {
        if (!cancelled) setPoints([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [deviceId]);

  return { points, loading };
}
